"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { ApiService } from "@/lib/api"
import type { SocialLink } from "@/lib/types/settings.types"
import { getSocialPlatformIcon, getSocialPlatformLabel } from "@/lib/social/platforms"

export default function FooterSocialLinks() {
  const [links, setLinks] = useState<SocialLink[]>([])

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        const settings = await ApiService.getGeneralSettings()
        if (!mounted) return
        const valid =
          settings.socialLinks?.filter((item) => item.url?.trim()) ?? []
        setLinks(valid)
      } catch {
        if (mounted) setLinks([])
      }
    }
    void load()
    return () => {
      mounted = false
    }
  }, [])

  if (links.length === 0) return null

  return (
    <div className="flex gap-3">
      {links.map((link, index) => {
        const Icon = getSocialPlatformIcon(link.platform)
        const label = getSocialPlatformLabel(link.platform)
        return (
          <Link
            key={`${link.platform}-${index}`}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-muted hover:bg-primary transition-colors flex items-center justify-center group"
            aria-label={label}
          >
            <Icon className="w-4 h-4 text-muted-foreground group-hover:text-primary-foreground transition-colors" />
          </Link>
        )
      })}
    </div>
  )
}
